import { render, staticRenderFns } from "./UploadCertificado.vue?vue&type=template&id=795eec62&scoped=true"
import script from "./UploadCertificado.vue?vue&type=script&lang=js"
export * from "./UploadCertificado.vue?vue&type=script&lang=js"
import style0 from "./UploadCertificado.vue?vue&type=style&index=0&id=795eec62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795eec62",
  null
  
)

export default component.exports